import { usePlayerRule } from "@/hooks/usePlayerRule/usePlayerRule";
import { useTimelineModePicker } from "@/hooks/useTimelineModePicker/useTimelineModePicker";
import { TimelineModePicker } from "../TimelineModePicker";
import { ToggleSpeakers } from "../ToggleSpeakers";

import { useBaseStore } from "@/store/store";

export function PlayerTimelineActionsPicker() {
  const mode = useBaseStore((store) => store.mode);
  const setMode = useBaseStore((store) => store.setMode);
  const { hasSentiments, shouldShowTimelineModePicker } = usePlayerRule();

  const { handleOnClickSimple, handleOnClickKaraoke, handleOnClickSentiments } =
    useTimelineModePicker();

  if (!shouldShowTimelineModePicker || !mode) {
    return null;
  }

  // display 2 modes when we don't have sentiment
  if (!hasSentiments) {
    return <ToggleSpeakers mode={mode} setMode={setMode} />;
  }

  // display 3 modes when we have sentiment
  return (
    <TimelineModePicker
      mode={mode}
      onClickSimple={handleOnClickSimple}
      onClickKaraoke={handleOnClickKaraoke}
      onClickSentiments={handleOnClickSentiments}
    />
  );
}
